import script from "./CustomButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomButton.vue?vue&type=script&setup=true&lang=ts"

import "./CustomButton.vue?vue&type=style&index=0&id=2de6b112&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2de6b112"]])

export default __exports__